module.exports = __webpack_public_path__ + "static/media/cover1.0566eac9.jpg";